<template>
  <div
    class="data-table"
    :class="{ subtable: type === 'subtable' }"
  >
    <div
      ref="headerOfList"
      class="data-table__header__row"
      :class="{ 'data-table__header__row--sticky': stickyActivated }"
    >
      <div
        v-for="(header, index) in header"
        :key="index"
        class="data-table__header__row__cell"
        :class="'column-size__' + header.size"
        :style="{ width: header.size }"
      >
        <h3>
          {{ header.title }}
          <template v-if="header.infoIcon">
            <svg-loader
              :id="'info-icon-' + header.title"
              class="header-title-info-icon"
              src="/static/images/icon-info.svg"
              @click.native="emitInfoIconAction(header.title)"
            />
            <md-tooltip md-direction="top">
              {{ header.infoIconTooltipText }}
            </md-tooltip>
          </template>
        </h3>
        <p>{{ header.subtitle }}</p>
        <component :is="header.component" v-if="header.component"/>
      </div>
    </div>

    <slot />
  </div>
</template>

<script>
export default {
  name: 'DataTable',
  props: {
    header: Array,
    type: {
      default: 'regular',
      type: String
    },
    isSticky: Boolean
  },
  data() {
    return {
      stickyActivated: false
    }
  },
  computed: {
    headerPosition() {}
  },
  created() {
    if (this.isSticky) window.addEventListener('scroll', this.turnHeaderListFixed)
  },
  beforeDestroy() {
    if (this.isSticky) window.removeEventListener('scroll', this.turnHeaderListFixed)
  },
  methods: {
    emitInfoIconAction(headerTitle) {
      this.$emit('info-icon-' + headerTitle)
    },
    turnHeaderListFixed() {
      const headerPosition = this.$refs.headerOfList.offsetTop - 58

      if (window.pageYOffset > headerPosition) this.stickyActivated = true
      else this.stickyActivated = false
    }
  }
}
</script>

<style lang="scss">
  .data-table {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;

    .subtable {
      width: 100%;
      padding: 0px 31px 29px;
      background: #f3f3f3;
      border-radius: 3px;

      .data-table__header__row {
        height: 2.5em;
      }
    }

    .header-title-info-icon {
      width: 15px;
      height: 15px;
      min-width: 15px;
      min-height: 15px;
      margin-bottom: 1px;
      color: #b7b7b7;
      cursor: pointer;

      &:hover {
        color: #7a7a7a;
      }
    }

    .column {
      &-center {
        margin: auto !important;
      }

      &-size {
        &__3 {
          width: 5%;
        }

        &__5 {
          width: 5%;
        }

        &__8 {
          width: 8%;
        }

        &__10 {
          width: 10%;
        }

        &__13 {
          width: 13%;
        }

        &__15 {
          width: 15%;
        }

        &__17 {
          width: 15%;
        }

        &__20 {
          width: 20%;
        }

        &__25 {
          width: 25%;
        }

        &__30 {
          width: 30%;
        }

        &__35 {
          width: 35%;
        }

        &__39 {
          width: 39%;
        }

        &__40 {
          width: 40%;
        }

        &__45 {
          width: 45%;
        }

        &__50 {
          width: 50%;
        }

        &__54 {
          width: 54%;
        }

        &__60 {
          width: 60%;
        }

        &__65 {
          width: 65%;
        }

        &__70 {
          width: 70%;
        }

        &__80 {
          width: 80%;
        }

        &__85 {
          width: 85%;
        }

        &__90 {
          width: 90%;
        }

        &__100 {
          width: 100%;
        }
      }
    }

    &__header,
    &__body {
      &__row {
        display: flex;
        flex-direction: row;

        &--subtable {
          display: flex;
          flex-direction: row;
        }

        &__cell {
          padding: 10px;
        }
      }
    }

    &__header {
      &__row {
        margin-top: 1em;
        height: 60px;

        &__cell {
          font-family: Roboto, sans-serif;
          font-style: normal;
          font-weight: 500;
          line-height: 14px;
          letter-spacing: 1px;
          text-transform: uppercase;
          color: #7a7a7a;
          align-items: center;

          h3 {
            font-size: 12px;
          }

          p {
            font-size: 10px;
          }
        }

        &--sticky {
          position: fixed;
          top: 58px;
          padding: 0 12em;
          width: calc(100% - 50px);
          min-width: 900px;
          margin-left: 50px;
          margin-top: 0;
          left: 0;
          background: #ebebeb;
        }
      }
    }

    &__body {
      &__row {
        border-radius: 3px;
        background: white;
        margin-bottom: 1em;
        display: flex;
        flex-wrap: wrap;

        &--subtable {
          background: none;
        }

        &__cell {
          font-family: Roboto, sans-serif;
          font-style: normal;
          height: auto;
          margin: auto 0;

          h3 {
            font-weight: bold;
            font-size: 16px;
          }

          p {
            font-size: 12px;

            &.sample-id {
              font-size: 14px;
            }
          }

          button {
            width: 100%;
            padding-right: 10px;

            svg path {
              fill: #fff;
            }
          }
        }
      }
    }

    .traceability-show-ready-exams-modal__modal .btn-close {
      width: 11px;
      height: 40px;

      .md-icon path {
        fill: #7f1a55;
      }
    }
  }
</style>
